import React from 'react'
import { useTranslation } from "react-i18next";

const ViewTextGenericMultilevel = ({ values, field, moduleText, occupation = 6, css_class }) => {
    const { t } = useTranslation();

    const hasInformation = values[field] && values[field].name ? true : false;

    const ViewTextGenericMultilevelRender = () => {
        if (!hasInformation) {
            return null;
        }

        return (
            <div className={`col-md-${occupation} ${css_class} viewContentGroup`}>
                <label htmlFor={field} className="tit-view-view tit-content-view-view">
                    {t(`${moduleText}.synthetic.${field}`)}
                </label>
                <div
                    className="txt-view viewContentTxt"
                    name={field}
                    id={field}
                >
                    {values[field] && values[field].name}
                </div>
            </div>
        );
    }

    return (
        <ViewTextGenericMultilevelRender />
    )

}

export default ViewTextGenericMultilevel